import axios from "axios";
import { useEffect, useState } from "react";
import loadIcon from '../images/loader2.webp';
import Select from "react-select";
import { setSeconds } from "date-fns";
import excel from '../images/excelicon.png';
import { exportArrayToExcel } from "../common/mylib";
import rcpt from '../images/rcpt.jpeg';
const Ledger=()=>
{
    const [facilities,setFacilities]=useState([]);
    const [customers,setCustomers]=useState([]);
    const [selectedFacility,setSelectedFacility]=useState("0");
    const [startDate,setStartDate]=useState("2025-01-01");
    const [endDate,setEndDate]=useState(new Date().toISOString().split("T")[0]);
    const [ledgerData,setLedgerData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [ledgertitle,setLedgerTitle]=useState("");
    const [progress,setProgress]=useState(false);


    const apiClient = axios.create({
                            baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization':'Bearer '+localStorage.getItem("token")
                            }
                        });  
    const customerOptions = customers.map(c => ({
                            value: c.id,
                            label: `${c.sname}${c.company ? " - " + c.company : ""}`,
                            data: c
                        })); 
    
    async function filterData(event)
    {
        if(event.target.value.length>=3)
        {
            let arr=ledgerData.filter((e)=>e.name.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.company.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.accounthead.toLowerCase().indexOf(event.target.value.toLowerCase())>=0);
            setDataToDisplay([...arr]);
        }
        else
        {
            setDataToDisplay([...ledgerData]);
        }
    }
    async function searchData(event)
    {       
        let start=startDate;
        let end=endDate;        
        if(event.target.id=="dtStart")
        {
            setStartDate(event.target.value);
            start=event.target.value;
        }
        if(event.target.id=="dtEnd")
        {
            setEndDate(event.target.value);
            end=event.target.value;
        }        
        setProgress(true);
        await apiClient.get("/api/Payment/GetAllTransactions/"+start+"/"+end).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setLedgerData(reply.data.data);                
                setDataToDisplay(reply.data.data);
            }
        });
        setProgress(false);
        /*
        {
            setProgress(true);
            await apiClient.get("/api/Payment/GetFacilityTransactionsByIdInDateRange/"+fac+"/"+start+"/"+end).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    setLedgerData(reply.data.data);   
                    setDataToDisplay(reply.data.data);             
                }
            });
            setProgress(false);
        }*/
    }
    async function loadData()
    {
        setProgress(true);
        let d1=new Date();
        d1.setMonth(d1.getMonth()-1);
        let d2=new Date();
        let start=d1.toISOString().split("T")[0];
        let end=d2.toISOString().split("T")[0];
        await apiClient.get("/api/Payment/GetAllTransactions/"+start+"/"+end).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setLedgerData(reply.data.data);                
                setDataToDisplay(reply.data.data);
            }
        });        
        setProgress(false);
    }
    useEffect(()=>{
        loadData();
        let d1=new Date(); 
        d1.setMonth(d1.getMonth()-1);        
        setStartDate(d1.toISOString().split("T")[0]);        
    },[]);
    return(
        <>
            <div className="row">                
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-6">
                    <input type="text" onChange={filterData} className="form-control form-control-sm" placeholder="Search Name/Company/Account Head..." style={{maxWidth:'250px'}} />
                    {/*<Select onChange={(option) =>{setSelectedCustomer(option.data);}} options={customerOptions} placeholder="Search subscriber..." isClearable classNamePrefix="react-select"> </Select>*/}
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-4">
                    <input onChange={searchData} type="date" id="dtStart" className="form-control form-control-sm" value={startDate} />
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-4">
                    <input onChange={searchData} type="date" id="dtEnd" className="form-control form-control-sm" value={endDate} />                                    
                </div>                                
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-4">
                    <img onClick={()=>{exportArrayToExcel(dataToDisplay,'Ledger')}} src={excel} style={{width:'30px',marginLeft:'10px',cursor:'pointer'}} />
                </div>                                
            </div>
            <div style={{overflow:"auto",fontSize:'12px',marginTop:'10px'}}>
                <div className="fw-bold">{ledgertitle}</div>
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>Name</th>
                            <th>Company</th>                            
                            <th>Account Head</th>
                            <th>Debit/Credit</th>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Details</th>
                            <th>Receipt</th>
                        </tr>                                    
                    </thead>
                    <tbody>
                        {dataToDisplay.map((e,i)=>
                            <tr key={i}>
                                <td>{i+1}</td>
                                <td>{e.name}</td>
                                <td>{e.company}</td>
                                <td>{e.accounthead}</td>
                                <td className={e.ttype=="C"?"table-primary":"table-danger"}>{e.ttype}</td>
                                <td>{e.tdate.substring(0,10).split("-").reverse().join("-")}</td>
                                <td>&#8377; {e.amount}</td>
                                <td>{e.tdetails}</td>
                                <td>{(e.accounthead=="Rent" && e.ttype=="C") &&(<a href={process.env.REACT_APP_APIURL+"/api/DownloadReceipt/"+new Date().getFullYear()+e.id} target="_blank"><img src={rcpt} width="20px"/></a>)}</td>
                            </tr>
                        )}            
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colSpan="3">Total Transactions: {dataToDisplay.length}</th>
                            <th colSpan="3"></th>
                            <th colSpan="3">
                                Debit Amount: &#8377; {dataToDisplay.filter(e=>e.ttype=="D").reduce((sum,item)=>sum+Number(item.amount),0)}<br/>
                                Credit Amount: &#8377; {dataToDisplay.filter(e=>e.ttype=="C").reduce((sum,item)=>sum+Number(item.amount),0)}<br/>
                            </th>
                        </tr>
                    </tfoot>
                </table>                                    
            </div>
            {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </>
    );
}
export default Ledger;